/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-14 09:25:32
 */

import {Component} from 'vue-property-decorator'
import BasicSearchPage from "src/components/basicSearchPage/basicSearchPage";
import DataViewApi, {DataViewDOI} from "./api/dataViewApi";
import './dataViewDetailList.less';
import { createBEM, createNamespace } from 'src/util/bem';
import QueryForm from 'src/components/queryForm/queryForm';
import override from "../../../dectorators/override";
import DataViewDetailListService from './service/dataViewDetailListService';
import Bus, { Events } from 'src/util/bus';
import { StationListDOI } from 'src/pages/stationList/api/stationListApi';
import MenuBtn from 'src/pages/layout/components/menuBtn';
import Tab from 'src/components/tab/tab';
import Button from 'src/types/iview/Button';
import FileUtil from 'src/util/fileUtil';
import alertHandMadeDataModal from './handMadeDataModal';
let bem = createBEM('data-view-detail-list')

@Component({name: 'data-view-detail-list'})
export default class DataViewDetailList extends BasicSearchPage<DataViewDetailListService, DataViewDOI.QueryDetailRowI, DataViewDOI.QueryDetailParamsI> {

    className: string = bem()+ ' '+ createNamespace('pt0')

    currentDataType: string = ''
    allDataType: {name: string, value: string}[] = []
    dataType: {name: string, id: string}[] = []

    mn: string = ''
    loading: Boolean = false;


    tabChange(value) {
        // 质控数据
        if(value === '') {
            this.queryFormData[0].hide = false
            this.queryFormData[0].props.value = '2062'
        } else {
            this.queryFormData[0].hide = true
            this.queryFormData[0].props.value = ''
        }
        this.search()
    }

    // @override
    // renderHead(h) {
    //     return <div></div>
    // }
    
    async export() {
        if(this.loading == false){
            this.loading = true;
            var mn = this.searchParams["mn"];
            var cn = this.searchParams["cn"];
            var start_time = this.searchParams["start_time"];
            var end_time = this.searchParams["end_time"];
            let {code, data} = await DataViewApi.exportDatatimeSingleStation(mn, cn, start_time, end_time);
            if(code === 0) {
                FileUtil.download(data.download_url)
            }
            this.loading = false;
        }
    }

    async handleRowDoubleClick(params) {
        if (this.currentDataType !== '11000') return;
        const row = params.data;
        if (!row.DateTime) return;
        const time = row.DateTime.replace(/\//g, '-').replace('.000', '');
        await alertHandMadeDataModal(this.mn, time, row);
        this.search();
    }

    async handleAddEdit() {
        await alertHandMadeDataModal(this.mn);
        this.search();
    }
    @override
    renderQuery(h) {
		return <div class={bem('query')}>
            <Tab dataSource={this.allDataType} v-model={this.currentDataType} on-change={this.tabChange.bind(this)}></Tab>
            <div class={bem('query-form')}>
                <Button class={createNamespace('mb5')} type="info" on-click={this.handleAddEdit.bind(this)} v-show={this.currentDataType === '11000'}>新增编辑</Button>
                <QueryForm ref="queryForm" dataSource={this.queryFormData} on-search={this.search} showClear={false}/>
                <Button class={createNamespace('mb5')} type="info" on-click={this.export.bind(this)} loading={this.loading}>导出</Button>
            </div>
        </div>
    }

    created() {
        this.lifyCreated();
        this.gridOptions.onRowDoubleClicked = (params) => {
            this.handleRowDoubleClick(params);
        };
    }

    @override
    async mounted () {
        this.mn = this.$route.query.mn
        this.currentDataType = this.$route.query.cn
        await this.service.queryAllDataType()
        await this.service.queryDataType()
		this.service.initSearchParams()
        this.searchTable()
        Bus.$on(Events.StationChange, this.stationChange)
    }

    stationChange(data: StationListDOI.RowDataI) {
        this.mn = data.mn
        this.search()
    }


    beforeDestroy() {
        Bus.$off(Events.StationChange, this.stationChange)
    }

	@override
	loadService () {
		this.service = new DataViewDetailListService(this)
	}
}